<span *ngIf="hideLabel !== true"
    >{{ _i18n._10003_TOTAL_ | translate }}&nbsp;</span
>
<span
    >{{ numerator | cmpsNumber: '1.2-2' }}/{{
        denominator | cmpsNumber: '1.2-2'
    }}&nbsp;</span
>
<span>({{ percentage | cmpsPercent: '1.2-2' }})</span>
